import { REHYDRATE } from 'redux-persist';
import wellknown from 'wellknown';

const initialState = {
  selectedCropYear: '',
  cropYearsDropDownListDataSource: [],
  fetchingFarmFields: false,
  farmFields: [],
  selectedFarmField: null,
  carbonScoringAnswers: {},
  savingAnswers: false,
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {

    case REHYDRATE:
      if (action.payload) {
        return {
          ...state,
          ...action.payload.carbonScoring,
          selectedCropYear: '',
          cropYearsDropDownListDataSource: [],
          fetchingFarmFields: false,
          farmFields: [],
          selectedFarmField: null,
          carbonScoringAnswers: {},
          savingAnswers: false,
        };
      }
      return state;

    case 'INIT_CARBON_SCORING_INTERFACE':
      return {
        ...state,
        selectedCropYear: '',
        cropYearsDropDownListDataSource: [],
        fetchingFarmFields: false,
        farmFields: [],
        selectedFarmField: null,
        carbonScoringAnswers: {},
        savingAnswers: false,
      };

    case 'FETCHED_CARBON_SCORING_CURRENT_CROP_YEAR':
      return {
        ...state,
        selectedCropYear: action.currentCropYear[0].CropYear,
      };

    case 'FETCHED_CARBON_SCORING_CROP_YEARS':
      var cropYearsDropDownListDataSource = [];
      action.cropYears.forEach((cropYear) => {
        cropYearsDropDownListDataSource.push({
          label: cropYear.CropYear,
          value: cropYear.CropYear,
        });
      });
      return {
        ...state,
        cropYearsDropDownListDataSource: cropYearsDropDownListDataSource,
      };

    case 'FETCHED_CARBON_SCORING_FARM_FIELDS_STARTED':
      return {
        ...state,
        fetchingFarmFields: true,
        farmFields: [],
        selectedFarmField: null,
        carbonScoringAnswers: {},
      };

    case 'FETCHED_CARBON_SCORING_FARM_FIELDS':
      (action.farmFields || []).forEach(field => {
        field.GoogleMapFieldPolygons = [];
        if (!field.boundaryWKT) {
          return;
        }
        const polygons = wellknown.parse(field.boundaryWKT);
        if (polygons === null) {
          return;
        }
        polygons.coordinates.forEach(polygonCoordinates => {
          var polygonCoords = [];
          if (polygons.type === 'MultiPolygon') {
            polygonCoordinates[0].forEach(c => {
              polygonCoords.push({
                lat: c[1],
                lng: c[0],
              });
            });
          }
          else {
            polygonCoordinates.forEach(c => {
              polygonCoords.push({
                lat: c[1],
                lng: c[0],
              });
            });
          }
          field.GoogleMapFieldPolygons.push(polygonCoords);
        });
      });
      return {
        ...state,
        farmFields: action.farmFields,
        selectedFarmField: null,
        carbonScoringAnswers: {},
        fetchingFarmFields: false,
      };

    case 'FETCHED_CARBON_SCORING_FARM_FIELDS_FAILED':
      return {
        ...state,
        fetchingFarmFields: false,
      };

    case 'USER_SELECTED_CARBON_SCORING_CROP_YEAR':
      return {
        ...state,
        selectedCropYear: action.selectedCropYear,
      };

    case 'USER_SELECTED_CARBON_SCORING_FARM_FIELD':
      return {
        ...state,
        selectedFarmField: action.selectedFarmField,
      };

    case 'FETCHED_CARBON_SCORING_ANSWERS':
      return {
        ...state,
        carbonScoringAnswers: action.answers || {},
      };

    case 'SUBMITTING_CARBON_SCORING_ANSWERS_STARTED':
      return {
        ...state,
        savingAnswers: true,
      };

    case 'SUBMITTED_CARBON_SCORING_SUCCESS':
      return {
        ...state,
        selectedFarmField: null,
        carbonScoringAnswers: {},
        savingAnswers: false,
      };

    case 'SUBMITTING_CARBON_SCORING_ANSWERS_FAILED':
      return {
        ...state,
        savingAnswers: false,
      };
      
    default:
      return state;
  }
}
